export const ItemTypes = {
  CARD: "Card",
};

export const PASSWORD_MIN_LENGTH = 8;
